//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import * as Utils from "eai-configurator-ui/components/Utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorMessageDialog, {useErrorMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";
import {useConfigProfile} from "eai-configurator-ui/components/configuration/profile/ConfigurationProfile";

const SaveConfigurationButton = ({
  url,
  icon,
  label,
  handleSuccess,
  ...props
}) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [errorMessage, setErrorMessage] = useErrorMessageDialog();

  const [configProfile] = useConfigProfile();
  const handleSubmit = () => {
    if (!submitted) {
      setSubmitted(true);

      let urlWithDefinition = url;
      if (configProfile && configProfile.name) {
        urlWithDefinition += "?definition=" + configProfile.name;
      }
      // Submit extraction
      Utils.fetchData(
        urlWithDefinition,
        {
          method: "post",
          body: JSON.stringify({
            values: Config.buildConfigurationValueDtos(),
          }),
        },
        true,
        false
      )
        .then((response) => {
          setSubmitted(false);
          if (handleSuccess) {
            handleSuccess();
          }
        })
        .catch(function (response) {
          setSubmitted(false);
          Utils.getErrorMessage(response, "Request failed.").then(
            setErrorMessage
          );
        });
    }
  };

  return (
    <div>
      <ErrorMessageDialog {...errorMessage} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        style={{ padding: "4px 10px" }}
        disabled={submitted}
        startIcon={
          submitted ? <CircularProgress color="inherit" size={20} /> : icon
        }
        {...props}
      >
        {label}
      </Button>
    </div>
  );
};
export default SaveConfigurationButton;
